import { render, staticRenderFns } from "./userForm.vue?vue&type=template&id=06c4c9a6&scoped=true"
import script from "./userForm.ts?vue&type=script&lang=ts&external"
export * from "./userForm.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06c4c9a6",
  null
  
)

export default component.exports